import * as maptilersdk from '@maptiler/sdk';
import { RefObject } from 'react';

let map: maptilersdk.Map;

const createMap = (
  mapRef: RefObject<HTMLDivElement>,
  controlPosition?: maptilersdk.ControlPosition,
): maptilersdk.Map | undefined => {
  if (!mapRef.current) return;

  try {
    map = new maptilersdk.Map({
      attributionControl: false,
      container: mapRef.current,
      geolocateControl: false,
      maxZoom: 24,
      minZoom: 0,
      navigationControl: false,
      scaleControl: 'bottom-left',
      style: maptilersdk.MapStyle.STREETS,
      zoom: 5,
    });
  } catch (error) {
    console.error('Failed to initialize map:', error);
  }

  if (!map) return;

  if (!controlPosition) return map;

  const fullscreenControl = new maptilersdk.FullscreenControl();
  const navigationControl = new maptilersdk.NavigationControl({
    showCompass: false,
  });

  map.addControl(fullscreenControl, controlPosition);
  map.addControl(navigationControl, controlPosition);

  return map;
};

const mapConfig = {
  createMap,
};

export default mapConfig;
